"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _DetailsTabModule = _interopRequireDefault(require("../../styles/components/TabsContent/DetailsTab.module.css"));
var _constants = require("../../utils/constants");
var _hooks = require("../../hooks");
var _Gallery = require("../Gallery");
var _function = require("../../utils/function");
var _InfoTitle = require("./InfoTitle");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const InfoContentRender = _ref => {
  let {
    fieldKey = null,
    componentId = null,
    type = '',
    fields = []
  } = _ref;
  const component = (0, _hooks.useGetComponentByTypeAndId)({
    type,
    id: componentId
  }) || {};
  const tv = (0, _paulCorePackage.useTranslationValue)();
  const tI = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUIComponentInfo);
  const label = (0, _react.useMemo)(() => tI[fields[fieldKey]] || '-', [tI, fields[fieldKey]]);
  const value = (0, _react.useMemo)(() => tv((0, _function.getTranslationsObjFromValue)(component[fieldKey])), [tv, component[fieldKey]]);
  return (0, _react.useMemo)(() => value ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "text_crop_3 w-100"
  }, label), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(_DetailsTabModule.default.detail_content, " text_crop_3")
  }, value)) : null, [tv, value, label]);
};
const _DetailsTab = _ref2 => {
  let {
    componentId,
    type = ''
  } = _ref2;
  const {
    thingHtgSysDistrictHeatingType,
    subtype
  } = (0, _hooks.useGetComponentByTypeAndId)({
    type,
    id: componentId
  }) || {};
  const fields = _constants.fieldsConfig[type === _paulCorePackage.constants.ComponentTypes.HtgSys && !thingHtgSysDistrictHeatingType ? subtype : type];
  const tv = (0, _paulCorePackage.useTranslationValue)();
  const webpSupport = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getWebpSupport);
  const {
    source: sourceURL
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getUrls);
  const defaultImgUrl = (0, _react.useMemo)(() => (0, _function.getDefaultImg)({
    sourceURL,
    type,
    webpSupport,
    imgSize: _paulCorePackage.constants.imgSizeKeys.original
  }), [sourceURL, type, webpSupport]);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement("div", {
    className: _DetailsTabModule.default.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_DetailsTabModule.default.img_wrap)
  }, /*#__PURE__*/_react.default.createElement(_Gallery.Gallery, {
    equipmentId: componentId,
    defaultImg: defaultImgUrl
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _DetailsTabModule.default.detail_container
  }, /*#__PURE__*/_react.default.createElement(_InfoTitle.InfoTitle, {
    type: type,
    componentId: componentId
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _DetailsTabModule.default.info
  }, Object.keys(fields).map(key => /*#__PURE__*/_react.default.createElement(InfoContentRender, {
    fieldKey: key,
    key: key,
    componentId: componentId,
    type: type,
    fields: fields
  }))))), [componentId, type, fields, tv, defaultImgUrl]);
};
var _default = _DetailsTab;
exports.default = _default;